import React, { Component } from 'react';
import "./MeSummary.css"

class MeSummary extends Component {
  constructor(props) {
    super(props);
  }

  getURL = () => {
    let retVal = "";
    const fullString = window.location.href;
    const tempString = fullString.split("//");
    retVal = tempString[1].split("/")[0];
    return retVal;
  }

  getText = () => {
    const urlString = this.getURL().toLowerCase();

    switch (urlString) {
      case "www.charles-w-roberts.com":
        {
          return (
            <div>

              <p>I have a Bachelor's degree in Electrical Engineering from Georgia Tech
                and a Master's degree in computer science from Clemson. I also have a
                proven history of engineering experience in hardware design and software
                design doing embedded programming.</p>

              <p>In 2017 I installed Mantis and OpenDocMan, two Linux, Apache, mySQL,
              PHP web applications on my household computer to manage household tasks
              and allow my wife and me to have a "paperless" household.</p>

              <p>My experience with those two LAMP applications piqued my interest
              in web applications, and then when a former co-worker of mine told me
              she had attended a Georgia Tech Professional Education web application
              course, I investigated and then signed up for the program.</p>

              <p>Web application design is an art and a science. Presenting information
              in a readily understood, and uncomplicated manner can be a daunting task,
            but it is one I enjoy.</p>

            </div>
          );
        } // End of case "www.charles-w-roberts.com":

      case "www.charlesroberts.org":
        {
          return (
            <div>

              <p>In 2017 I installed Mantis and OpenDocMan, two Linux, Apache, mySQL,
              PHP web applications on my household computer to manage household tasks
              and allow my wife and me to have a "paperless" household.</p>

              <p>My experience with those two LAMP applications piqued my interest
              in web applications, and then when a former co-worker of mine told me
              she had attended a Georgia Tech Professional Education web application
              course, I investigated and then signed up for the program.</p>

               <p>I have a Bachelor's degree in Electrical Engineering from Georgia Tech
              and a Master's degree in computer science from Clemson. I also have a
              proven history of engineering experience in hardware design and software
              design doing embedded programming.</p>

            </div>
          );
        } // End of case "www.charlesroberts.org":

      default:
        {
          return (
            <div>
              <p> Please send e-mail to Charles.Roberts@gatech.edu telling him that
                you saw this text on his webpage.  Also, please let him know the
                url you used to access this page.  Thank you.
          </p>
            </div>
          );

        } // End of the default case

    } // End of switch(urlString)

  } // End of getText()



  render() {
    return (

      <div className='MeSummaryMain'>

        {this.getText()}

      </div>

    );
  }

}


export default MeSummary;


// WEBPACK FOOTER //
// ./src/components/AboutMe/MeSummary.js